import { AppShellContent, Title } from "@assetwatch/ui";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { HomeScreen } from "../screens/HomeScreen";

function ModalityHomeRoute() {
  const { t } = useTranslation();

  return (
    <AppShellContent pageHeader={<Title size="lg">{t("home.title")}</Title>}>
      <HomeScreen />
    </AppShellContent>
  );
}

export const Route = createFileRoute("/_app/")({
  component: ModalityHomeRoute,
});
